import { Container, Error as ErrorPage, Layout } from 'metrix-common3';
import React from 'react';
import { BrowserRouter, Route, Routes as RouterRoutes } from 'react-router-dom';

import AppBar from '../AppBar';

const Login = React.lazy(() => import('../../containers/Login'));
const Home = React.lazy(() => import('../../containers/Home'));
const Dashboard = React.lazy(() => import('../../containers/Dashboard'));
const ResetPassword = React.lazy(() => import('../../containers/ResetPassword'));
const Register = React.lazy(() => import('../../containers/Register'));
const Settings = React.lazy(() => import('../../containers/Settings'));
const Profile = React.lazy(() => import('../../containers/Profile'));
const ClientCompanyProfile = React.lazy(() => import('../../containers/ClientCompanyProfile'));
const Documents = React.lazy(() => import('../../containers/Documents'));
const Inbox = React.lazy(() => import('../../containers/Inbox'));
const Cases = React.lazy(() => import('../../containers/Cases'));
const Notifications = React.lazy(() => import('../../containers/Notifications'));
const Unsubscribe = React.lazy(() => import('../../containers/Unsubscribe'));
const Administration = React.lazy(() => import('../../containers/Administration'));
const Activate = React.lazy(() => import('../../containers/Activate'));
const Broker = React.lazy(() => import('../../containers/Broker'));
const BrokerCompany = React.lazy(() => import('../../containers/BrokerCompany'));
const Lead = React.lazy(() => import('../../containers/Lead'));
const AppraisalProfile = React.lazy(() => import('../../containers/AppraisalProfile'));

const Routes = (props) => {
    const fallback = <Layout fullScreen loading appBar={<AppBar {...props} />} />;
    const fourOhFour = {
        errorStatus: '404',
        errorMsg: 'Page Not Found.',
        redirectionLocation: '/dashboard2',
        redirectionText: 'Home.',
    };

    const ErrorHandling = {
        errorStatus: 'API Call Failed',
        errorMsg: '...',
        redirectionLocation: '/dashboard2',
        redirectionText: 'Home.',
    };

    const withProps = (Component) => <Component {...props} />;
    const keyed = (Component, key) => <Component key={key} {...props} />;

    return (
        <BrowserRouter>
            <Container {...props}>
                <React.Suspense fallback={fallback}>
                    <RouterRoutes>
                        <Route path='/' element={withProps(Login)} />
                        <Route path='/activate' element={withProps(Activate)} />
                        <Route path='/dashboard' element={withProps(Dashboard)} />
                        <Route path='/administration' element={withProps(Administration)} />
                        <Route path='/resetpassword' element={withProps(ResetPassword)} />
                        <Route path='/register' element={withProps(Register)} />
                        <Route path='/settings' element={withProps(Settings)} />
                        <Route path='/profile' element={keyed(Profile, 'profile')} />
                        <Route path='/profile/:section' element={keyed(Profile, 'profile')} />
                        <Route
                            path='/clientCompanyProfile'
                            element={keyed(ClientCompanyProfile, 'clientCompanyProfile')}
                        />
                        <Route path='/appraisalProfile' element={keyed(AppraisalProfile, 'appraisalProfile')} />
                        <Route path='/documents' element={withProps(Documents)} />
                        <Route path='/inbox' element={<Inbox key={'inbox'} {...props} view={'inbox'} />} />
                        <Route path='/cases' element={withProps(Cases)} />
                        <Route path='/notifications' element={withProps(Notifications)} />
                        <Route path='/unsubscribe' element={keyed(Unsubscribe, 'unsubscribe')} />
                        <Route path='/broker/*' element={keyed(Broker, 'broker')} />
                        <Route path='/brokerCompany/*' element={keyed(BrokerCompany, 'brokerCompany')} />
                        <Route path='/lead' element={withProps(Lead)} />
                        <Route path='/404' element={<ErrorPage value={fourOhFour} />} />
                        <Route path='/error' element={<ErrorPage value={ErrorHandling} />} />
                        <Route
                            path='/unknown'
                            element={
                                <ErrorPage
                                    value={{
                                        errorMsg: 'Unknown Error!',
                                        errorStatus: '---',
                                        redirectionLocation: '/search',
                                        redirectionText: 'Home.',
                                    }}
                                />
                            }
                        />
                        <Route path='/*' element={withProps(Home)} />
                    </RouterRoutes>
                </React.Suspense>
            </Container>
        </BrowserRouter>
    );
};

export default Routes;
